import * as React from 'react';
import '../../../styles/UnitMap.css';
import Button from '../form/Button';
import { MapContext } from './UnitMapTypes';
import { useContext } from 'react';
import FloorDropDown from './FloorDropDown';
import { isMobile } from 'react-device-detect';
import TourStopDropDown from './TourStopDropdown';
import { ButtonGroup, Dropdown, DropdownMenu } from 'reactstrap';
import DropdownToggle from 'reactstrap/lib/DropdownToggle';
import Legend from './Legend';
import { browserHistory } from '../../../utilities/history';

interface Props {
    tourStopsOpen: boolean;
    legendOpen: boolean;
    handleTourStopClick: () => void;
    handleLegendClick: () => void;
}

const MapControls = (props: Props) => {
    const context = useContext(MapContext);
    const backArrow = require('../../../images/left-carot-small.png');
    return (
        <ButtonGroup className={`map-controls ${isMobile ? 'mobile' : ''}`}>
            <div className="back-button" onClick={browserHistory.goBack}>
                <img src={backArrow} />
            </div>
            {isMobile && (
                <Dropdown isOpen={props.tourStopsOpen} toggle={props.handleTourStopClick}>
                    <DropdownToggle
                        key={'stops'}
                        className={`btn font-weight-bold dropdown mr-1 ${
                            props.tourStopsOpen ? 'btn-primary' : 'btn-light'
                        }`}
                    >
                        Stops
                    </DropdownToggle>
                    <TourStopDropDown
                        isOpen={props.tourStopsOpen}
                        handleCloseModal={props.handleTourStopClick}
                    />
                </Dropdown>
            )}
            <FloorDropDown />
            {context.map && context.map.geo().isSupported() && (
                <Button
                    key={'locate'}
                    text={''}
                    addlClassName={`ml-1 ${context.locationEnabled ? 'btn-primary' : 'btn-light'}`}
                    suppressBottomMargin={true}
                    disabled={!navigator.geolocation}
                    onClick={() => {
                        if (context.locationEnabled) {
                            context.map.locator().hide();
                            context.setLocationEnabled(false);
                        } else {
                            context.map.locator().show();
                            context.setLocationEnabled(true);
                        }
                    }}
                >
                    My Location
                </Button>
            )}
            <Dropdown isOpen={props.legendOpen} toggle={props.handleLegendClick}>
                <DropdownToggle
                    key={'legend'}
                    className={`btn font-weight-bold dropdown ml-1 ${
                        props.legendOpen ? 'btn-primary' : 'btn-light'
                    }`}
                >
                    Legend
                </DropdownToggle>
                <DropdownMenu right={true}>
                    <Legend title={'Legend'} />
                </DropdownMenu>
            </Dropdown>
        </ButtonGroup>
    );
};
export default MapControls;



// WEBPACK FOOTER //
// ./src/components/common/UnitMap/MapControls.tsx